import authHeader from "@/services/auth-header";

const axios = require('axios');
const API_URL='https://www.dev.ekhonidaktar.com/api';

class FetchPatientService {

    fetchPatient(user_id){
        return axios.get(`${API_URL}/users/${user_id}/patients`, {headers: authHeader()});
    }

}

export default new FetchPatientService();